<template>

  <div class="panel panel-clinic prospect">

    <div class="panel-heading collapsed" href="#form_contract" data-toggle="collapse">

      <div class="arrow-down"></div>

      <h2 class="panel-title">Avtal</h2>

    </div>

    <div id="form_contract" class="panel-collapse collapse">

      <div class="panel-body">

        <h3>Status</h3>

        <div class="form-horizontal">

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :extra-data="{
                        	'Prospekt': 1,
                        	'Inaktiv': 3,
                        	'Aktiv': 2,
                        	'Pausad': 5,
                        	'Avslutad': 4,
                        	'Avslutat prospekt': 6,
                        	'Inaktivt prospekt': 7,
                        	'Gammal prospect': 8
                        }"
            :showComment="true"
            type="select_status"
            layout="selectMenu"
            title="Status">
          </row-meta>

        </div>

        <div v-show="!showContract()">

          <h3>Ladda ner och skriv avtal</h3>

          <div class="clinic-outer-form-group oddevencol" style="background-color:#e1f0ef;">
            När hela prospektet är ifyllt kan avtal laddas ner för påskrift av Hälsoresurs och massör. Om en eller flera
            rader inte kan fyllas i, kryssa "Hoppa över", så kan avtal skapas ändå.<br>
            Färdiga avtal kan sedan laddas upp, för att på så vis godkänna massören och aktivera Mottagningsmassage
            eller Företagsmassage.
          </div>

        </div>

        <div v-show="showContract()">

          <h3>Ladda ner avtal för underskrift</h3>
          <p class="comment subline">När vi är överens och fysiskt avtal ska skickas ut för påskrift. Vald person från
            listan ska signera innan avtalet postas (i 2 exemplar).</p>
          <div class="clinic-outer-form-group agreement">

            <div v-show="validateRule('rule_has_prices_internal') && clinic.address_id">

              <row-meta
                :clinic-id="clinic.id"
                :row-meta="meta"
                :showForced="false"
                :showDate="true"
                :showComment="true"
                :extra-data="admins"
                type="contract_download_internal"
                layout="contractDownload"
                title="Mottagningsmassage">
              </row-meta>

            </div>

            <div v-show="validateRule('rule_has_prices_external')">

              <row-meta
                :clinic-id="clinic.id"
                :row-meta="meta"
                :showForced="false"
                :showDate="true"
                :showComment="true"
                :extra-data="admins"
                type="contract_download_external"
                layout="contractDownload"
                title="Företagsmassage">
              </row-meta>

            </div>

			            <div v-show="validateRule('rule_has_prices_pt')">

				            <row-meta
				              :clinic-id="clinic.id"
				              :row-meta="meta"
				              :showForced="false"
				              :showDate="true"
				              :showComment="true"
				              :extra-data="admins"
				              type="contract_download_pt"
				              layout="contractDownload"
				              title="PT">
				            </row-meta>

			            </div>

					</div>

					<h3>Ladda upp underskrivna avtal</h3>
					<p class="comment subline">När avtalet kommit in påskrivet från partnern, laddas detta upp. Själva anslutningsprocessen påbörjas därmed, se processbeskrivning.</p>
					<div class="clinic-outer-form-group agreement">

            <div v-show="validateRule('rule_has_prices_internal') && clinic.address_id">

              <row-meta
                :clinic-id="clinic.id"
                :row-meta="meta"
                :showDate="false"
                :showComment="true"
                type="contract_upload_internal"
                layout="fileUpload"
                title="Mottagningsmassage">
              </row-meta>

            </div>

            <div v-show="validateRule('rule_has_prices_external')">

              <row-meta
                :clinic-id="clinic.id"
                :row-meta="meta"
                :showDate="false"
                :showComment="true"
                type="contract_upload_external"
                layout="fileUpload"
                title="Företagsmassage">
              </row-meta>

            </div>

			            <div v-show="validateRule('rule_has_prices_pt')">
			              <row-meta
			                :clinic-id="clinic.id"
			                :row-meta="meta"
			                :showDate="false"
			                :showComment="true"
			                type="contract_upload_pt"
			                layout="fileUpload"
			                title="PT">
			              </row-meta>
			            </div>

					</div>

					<h3>Anslutningsdatum</h3>
					<p class="comment subline">Här anges partnerns anslutningsdatum. Notera att avtalet måste laddas upp och koden aktiveras separat.</p>
					<div class="clinic-outer-form-group agreement">

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showDate="false"
              :showComment="true"
              type="date_connected_internal"
              layout="datePicker"
              title="Mottagningsmassage">
            </row-meta>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showDate="false"
              :showComment="true"
              type="date_connected_external"
              layout="datePicker"
              title="Företagsmassage">
            </row-meta>

						<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:showDate="false"
							:showComment="true"
							type="date_connected_pt"
							layout="datePicker"
							title="PT">
						</row-meta>

					</div>

					<h3>Avslutningsdatum</h3>
					<p class="comment subline">Här anges datum för en partner som avslutat sitt avtal. Notera att status, kod och ev. konto till massörsportal måste inaktiveras manuellt.</p>
					<div class="clinic-outer-form-group agreement">

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showDate="false"
              :showComment="true"
              type="date_disconnected_internal"
              layout="datePicker"
              title="Mottagningsmassage">
            </row-meta>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showDate="false"
              :showComment="true"
              type="date_disconnected_external"
              layout="datePicker"
              title="Företagsmassage">
            </row-meta>

						<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:showDate="false"
							:showComment="true"
							type="date_disconnected_pt"
							layout="datePicker"
							title="PT">
						</row-meta>

					</div>

          <h3>Orsak till uppsägning</h3>
          <p class="comment subline">Här anges en orsak till uppsägning.</p>
          <div class="clinic-outer-form-group agreement">
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :extra-data="{
                       'Välj': 1,
                       'Byter bana': 'Byter bana',
                       'Ersättning': 'Ersättning',
                       'Lokal': 'Lokal',
                       'Stänger ned': 'Stänger ned',
                       'Misskött samarbete': 'Misskött samarbete',
                       'Övrigt': 'Övrigt',
                        }"
              :showComment="true"
              type="select_reason_to_disconnected"
              layout="selectMenu"
              title="Orsak">
            </row-meta>
          </div>

					<h3>Aktivera koder och QR-registrering</h3>
					<p class="comment subline">Aktiveras oberoende av avtalen och anslutningsdatumen.</p>
					<div class="form-horizontal">
						<div class="form-group oddevencol">
							<div class="col-md-14 control-label">
								<label>Mottagningsmassage</label>
							</div>
							<div class="col-md-36">
								<input type="checkbox" true-value="1" false-value="0" v-model="clinic.contract_internal">
							</div>
						</div>

						<div class="form-group oddevencol">
							<div class="col-md-14 control-label">
								<label>Företagsmassage</label>
							</div>
							<div class="col-md-36">
								<div v-if="this.rowMetaComplete('text_timezynk_id')">
									<input type="checkbox" true-value="1" false-value="0" v-model="clinic.contract_external">
								</div>
								<div v-else>
									Ange TimeZynk-ID innan du aktiverar företagskod
								</div>
							</div>
						</div>

			            <div class="form-group oddevencol">
			              <div class="col-md-14 control-label">
			                <label>PT</label>
			              </div>
			              <div class="col-md-36">
			                <input type="checkbox" true-value="1" false-value="0" v-model="clinic.contract_pt">
			              </div>
			            </div>

					</div>

					<div v-show="clinic.contract_internal == 1 || clinic.contract_external == 1 || clinic.contract_pt == 1">

						<h3>Skicka ut välkomstmail</h3>
						<p class="comment subline">Efter att påskrivet avtal är uppladdat, skickas välkomstmail ut. Välj välkomstmail för de tjänster som partnern har.</p>

            <h3>Skicka ut välkomstmail</h3>
            <p class="comment subline">Efter att påskrivet avtal är uppladdat, skickas välkomstmail ut. Välj
              välkomstmail för Mottagning och/eller Företag beroende på vilket avtal som skrivits.</p>

            <div class="clinic-outer-form-group oddevencol"
                 style="background-color:#e1f0ef; margin-bottom: 30px;"
                 v-show="errors.email
							 	     || (errors.billing_phone
							 	     || clinic.billing_phone == null
							 	     || clinic.billing_phone == '')">

							<span v-show="errors.email">

								Partnerns e-post är inte giltligt, den måste bli korrekt innan välkomstmail kan skickas ut.
								<br /><br />

							</span>

              <span v-show="(errors.billing_phone || clinic.billing_phone == null || clinic.billing_phone == '')">

								Massörens telefonnummer är inte giltligt, det måste bli korrekt innan demokort kan skickas ut.

								<span v-show="!errors.email">
									Du kan fortfarande skicka ut välkomstmail, utan att demokort går iväg.
								</span>

							</span>

            </div>

						<div v-show="clinic.contract_internal == 1 && !errors.email" style="margin-bottom: 20px;">
							<div class="btn btn-default" v-on:click="sendWelcomeEmail('internal')">
								Mottagningsmassage
							</div>
							<div style="display: inline-block; margin-left: 15px;">
								{{ clinic.contract_internal_sent }}
							</div>
						</div>

						<div v-show="clinic.contract_external == 1 && !errors.email" style="margin-bottom: 20px;">
							<div class="btn btn-default" v-on:click="sendWelcomeEmail('external')">
								Företagsmassage
							</div>
							<div style="display: inline-block; margin-left: 15px;">
								{{ clinic.contract_external_sent }}
							</div>
						</div>

						<div v-show="clinic.contract_pt == 1 && !errors.email">
							<div class="btn btn-default" v-on:click="sendWelcomeEmail('pt')">
								PT
							</div>
							<div style="display: inline-block; margin-left: 15px;">
								{{ clinic.contract_pt_sent }}
							</div>
						</div>

						<br><br>
						<h3>Skicka ut demo av kundkonto</h3>
						<p class="comment subline">Här kan du skicka demokontot till partnern igen, vid behov. Partnern får alltid demokontot i välkomstmejlet vid anslutning.</p>

						<div v-show="(clinic.contract_internal == 1 || clinic.contract_external == 1)  && clinic.billing_phone && !errors.billing_phone">
							<div class="btn btn-default" v-on:click="sendDemoCard('massage')">
								Demokonto massage
							</div>
							<div style="display: inline-block; margin-left: 15px;">
								{{ clinic.demo_card_sent }}
							</div>
						</div>

            <br>

						<div v-show="clinic.contract_pt == 1  && clinic.billing_phone && !errors.billing_phone">
							<div class="btn btn-default" v-on:click="sendDemoCard('pt')">
								Demokonto PT
							</div>
							<div style="display: inline-block; margin-left: 15px;">
								{{ clinic.demo_card_pt_sent }}
							</div>
						</div>

                        <br><br>
                        <h3>Skicka ut sms med länk till massörsportalen (ej PT)</h3>
                        <p class="comment subline">Skicka ut sms med länk till massörsportalen</p>

            <div
              v-show="(clinic.contract_internal == 1 || clinic.contract_external == 1)  && clinic.billing_phone && !errors.billing_phone">
              <div class="btn btn-default" v-on:click="sendPortalLink()">
                Skicka länk
              </div>
              <div style="display: inline-block; margin-left: 15px;">
                {{ clinic.portal_link_sent_at }}
              </div>
            </div>
            <br>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

import mixin from './mixin'

export default {

    mixins: [mixin],

    data () {
        return {}
    },

    computed: {

        admins () {
            const admins = []

            admins.push({

                value: null,
                text: 'Välj person som ska underteckna'

            })

            _.forEach(_.filter(this.users, ['type', 'admin']), function (admin) {
                admins.push({

                    value: admin.name,
                    text: admin.name

                })
            })

            return admins
        }

    },

    methods: {

        sendWelcomeEmail (type) {
            const self = this

            console.log('sendWelcomeEmail ' + type)
            console.log('clinic id ' + self.clinic.id)

            self.$http.post('/clinics/sendWelcomeEmail', { clinic_id: self.clinic.id, type: type }).then((response) => {
                console.log(response.body)

                if (!response.body.error) {
                    bus.$emit('notify', 'Mail skickat till massören.')

                    bus.$emit('refresh-data')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        sendDemoCard (type) {
            const self = this

            self.$http.post('/clinics/sendDemoCard', { clinic_id: self.clinic.id, type: type }).then((response) => {
                console.log(response.body)

                if (!response.body.error) {
                    bus.$emit('notify', 'Demokort skickat till massören.')

                    bus.$emit('refresh-data')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        sendPortalLink () {
            const self = this

            self.$http.post('/clinics/sendPortalLink', { clinic_id: self.clinic.id }).then((response) => {
                console.log(response.body)

                if (!response.body.error) {
                    bus.$emit('notify', 'Sms skickat till massören.')

                    bus.$emit('refresh-data')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        showContract () {
            if (this.validateRule('rule_contact') &&
        this.rowMetaComplete('file_education') &&
        this.rowMetaComplete('file_cert') &&
        this.rowMetaComplete('file_ftax') &&
        this.rowMetaComplete('file_insurance') &&
        (((this.meta.trial_do.value == 1 || this.meta.trial_do.value == null) && this.rowMetaComplete('trial_booked') && this.rowMetaComplete('trial_done')) || this.meta.trial_do.value == 0)
            ) {
                return true
            }

            return false
        }

    }

}

</script>
